import React, { useEffect, useRef } from 'react';

const TrustpilotCarousel = () => {
    const trustpilotWidgetRef = useRef(null);
    useEffect(() => {
        // Function to attempt reinitialization of Trustpilot widgets
        const reinitializeTrustpilotWidgets = () => {
            if (window.Trustpilot && trustpilotWidgetRef.current) {
                window.Trustpilot.loadFromElement(trustpilotWidgetRef.current, true);
            }
        };

        // Observe the entire body for the addition of child elements if needed
        // You might not need a MutationObserver if you're just initializing once on component mount

        // Ensure Trustpilot widgets are reinitialized on initial load
        reinitializeTrustpilotWidgets();

        // Optionally, you might set up a MutationObserver or other logic here if you need to detect dynamic changes
    }, []);

    return (
        <div
            ref={trustpilotWidgetRef}
            className="trustpilot-widget bg-holborn-blue pt-12 pb-0 px-8 lg:px-0"
            data-locale="en-GB"
            data-template-id="539ad0ffdec7e10e686debd7"
            data-businessunit-id="58bff1ac0000ff00059e0e97"
            data-style-height="350px"
            data-style-width="100%"
            data-theme="dark"
            data-stars="4,5">
        </div>
    );
};

export default TrustpilotCarousel;